export default {"src":"/_next/static/media/WhoWeAre_031A.19cb615c.JPG","height":686,"width":1920};